import { useState } from 'react';
import { createApiClient } from '@shared/api/client/api-client';
import { createAuthApi } from '@shared/api/lib/auth-api';
import { useAuth } from '@entities/auth';
import { env } from '@shared/config/env';
import { mapPasswordApiError, type PasswordApiFailure } from '@entities/auth';
import type { User } from '@entities/auth';

export const useChangePassword = () => {
  const { login } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const changePassword = async (payload: {
    currentPassword: string;
    newPassword: string;
    code?: string;
    secondFactor?: { method: 'totp' | 'email' | 'backup'; code: string };
  }): Promise<
    { success: true; user?: User } | { success: false; failure: PasswordApiFailure | null }
  > => {
    setIsSubmitting(true);

    try {
      const authApi = createAuthApi(createApiClient({ baseURL: env.API_BASE_URL }));
      const response = await authApi.changePassword({
        currentPassword: payload.currentPassword,
        newPassword: payload.newPassword,
        ...(payload.code ? { code: payload.code } : {}),
        ...(payload.secondFactor ? { secondFactor: payload.secondFactor } : {}),
      });
      const user = await login(response.token);
      return { success: true, user };
    } catch (error: unknown) {
      return { success: false, failure: mapPasswordApiError(error) };
    } finally {
      setIsSubmitting(false);
    }
  };

  return { changePassword, isSubmitting };
};
